<template>
  <div>
    <b-row v-if="!setGlobalLoading && errorsMessage && errorsMessage.length" class="alert-messages pt-3">
      <b-col>
        <b-alert
          show dismissible
          variant="danger"
          v-for="(alertMessage, index) in errorsMessage"
          :key="'alert-msg-' + index.toString()"
          class="alert-height pr-5"
        ><div v-html="alertMessage"></div></b-alert>
      </b-col>
    </b-row>
    <StepTitle hr><div v-html="session.verify_message" class="how-can"></div></StepTitle>
    <b-form @submit.prevent="verify()" className="customer-verify-form">
      <b-row class="justify-content-md-center boxes customer-verification">
        <b-col md="8" lg="6">
          <VerificationField v-for="(field, index) in session.required_fields"
                             :key="'verification-field-' + index.toString()"
                             :method="field"
                             :value="values"
                             :placeholders="placeholders"
          >
          </VerificationField>
        </b-col>
      </b-row>
      <input id="country" type="hidden" v-model="values.country" />
      <b-row class="justify-content-md-center boxes customer-verify-btn customer-verify mt-4">
        <b-col v-if="session && session.can_undo && setGlobalLoading" md="4" lg="3" cols="6">
          <b-button block @click="goBack()" class="btn-outline-success btn-back" variant="outline-success">Back</b-button>
        </b-col>
        <b-col :md="setGlobalLoading ? 4 : 8" :lg="setGlobalLoading ? 3 : 6" :cols="session && session.can_undo && setGlobalLoading ? 6 : 12">
          <b-button @click="$event.stopPropagation()" :class="{'submit-and-verify': !setGlobalLoading}" block type="submit"  class="btn btn-default btn-account text-nowrap" variant="primary">
            <template v-if="setGlobalLoading"> Submit </template>
            <template v-else>
              SUBMIT & CONTINUE
              <span class="float-none float-sm-right pr-2">
                <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
              </span>
            </template>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <div ref="translation_detector" style="display:none;">{{translateDetectString}}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { TranslateTestString } from '../constants'
import { setPlaceholders } from '../utils'

const VerificationField = () => import('./VerificationField')
const StepTitle = () => import('./StepTitle')

export default {
  name: 'CustomerVerify',
  components: {
    VerificationField,
    StepTitle
  },
  props: {
    getCart: {
      type: Boolean,
      default: true
    },
    setGlobalLoading: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      retryCnt: 0,
      translateDetectString: TranslateTestString,
      values: {
        first_name: null,
        last_name: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        phone: null,
        email: null,
        country: null
      },
      placeholders: {
        first_name: '',
        last_name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        email: '',
        country: ''
      },
      errorsMessage: null
    }
  },
  computed: {
    ...mapState(['session', 'cartIsOpen'])
  },
  methods: {
    updateData: function(field, val) {
      this.values[field] = val
    },
    processPostMatch: function(session) {
      if (this.getCart) {
        this.$store.dispatch('get_cart')
      }
      this.$emit('done')
      if (!this.setGlobalLoading) {
        this.$emit('verifying', false)
      }
    },
    verify: function() {
      if (this.setGlobalLoading) {
        this.$store.commit('busy')
      } else {
        this.$emit('verifying', true)
      }
      this.$store.dispatch('verify', this.values)
        .then(session => this.processPostMatch(session))
        .catch(err => {
          if (err.response && err.response.status === 404) {
            this.retryCnt++
            let message = "Sorry, but we couldn't verify your information."

            if (this.retryCnt < 3) {
              message += "<br/>Make sure you typed it correctly and it's the same as when you placed your order."
              if (!this.setGlobalLoading) {
                this.errorsMessage = [message]
              } else {
                this.$store.commit('error', message)
              }
            } else {
              this.$emit('fail', message)
            }
          } else if (err.response && err.response.status === 400) {
            let errors = []

            Object.keys(err.response.data).forEach(key => {
              errors = errors.concat(err.response.data[key])
            })
            if (!this.setGlobalLoading) {
              this.errorsMessage = errors
            } else {
              this.$store.commit('error', errors)
            }
          } else if (err.response && err.response.status === 303 && err.response.data) {
            this.$store.commit('session', err.response.data)
            this.processPostMatch(err.response.data)
          } else {
            this.$store.commit('critical_error', err)
          }
          if (!this.setGlobalLoading) {
            this.$emit('verifying', false)
          } else {
            this.$store.commit('ready')
          }
        })
    },
    goBack: function() {
      this.$emit('back')
    }
  },
  mounted() {
    this.$store.dispatch('wait_for_translation', {element: this.$refs['translation_detector']})
      .then(value => {
        setTimeout(() => {
          setPlaceholders(this.placeholders)
        }, 100)
      })
  }
}
</script>

<style scoped>

</style>
